import { maAuthenticationGuard, maAuthorizationGuard } from '@/router/guards'
import { RouteName } from '@/base/constants/route'

const pdfReportRoutes = {
  path: 'pdf-report',
  name: RouteName.PDF_REPORT,
  meta: {
    title: 'Pdf Report',
    ignoreFromMenu: true,
  },
  component: () => import('@/layouts/PdfReport.vue'),
  redirect: { name: RouteName.NOT_FOUND },
  beforeEnter: [maAuthenticationGuard, maAuthorizationGuard],
  children: [
    {
      path: 'explore/:trackId?',
      name: RouteName.PDF_REPORT_EXPLORE,
      meta: {
        title: 'Explore',
      },
      component: () => import('@/pages/competitive-overview/pdf-report.vue'),
    },
  ],
}

export default pdfReportRoutes
